<template>
  <b-modal
    :active.sync="showQuizModal"
    has-modal-card
    :can-cancel="false"
    :width="680">
    <template>
      <validation-observer v-slot="{ handleSubmit }">
        <div class="modal-card">
          <header class="modal-card-head has-background-success has-text-centered">
            <h2 class="modal-card-title has-text-white has-text-weight-bold">
              <p>Help us learn about your business:</p>
            </h2>
          </header>

          <footer class="modal-card-foot">
            <form class="quiz-form">
              <validation-provider v-slot="{ errors }" rules="required">
                <b-field :label="select1.question" :type="{ 'is-danger': errors.length }">
                  <b-select :placeholder="placeholder"
                           :expanded=true
                            v-model="select1.answer">
                    <option value="Less than $100K">Less than $100K</option>
                    <option value="$100K - $1M">$100K - $1M</option>
                    <option value="$1M - $10M">$1M - $10M</option>
                    <option value="More than $10M">More than $10M</option>
                  </b-select>
                </b-field>
              </validation-provider>
              <validation-provider v-slot="{ errors }" rules="required">
                <b-field :label="select2.question" :type="{ 'is-danger': errors.length }">
                  <b-select :placeholder="placeholder"
                           :expanded=true
                            v-model="select2.answer">
                    <option value="Self - 1">Self - 1</option>
                    <option value="2 - 15">2 - 15</option>
                    <option value="16 - 25">16 - 25</option>
                    <option value="26 - 50">26 - 50</option>
                    <option value="More than 50">More than 50</option>
                  </b-select>
                </b-field>
              </validation-provider>
              <validation-provider v-slot="{ errors }" rules="required">
                <b-field :label="select3.question" :type="{ 'is-danger': errors.length }">
                  <b-select :placeholder="placeholder"
                            :expanded=true
                            v-model="select3.answer">
                    <option value="Less than 1">Less than 1</option>
                    <option value="2 - 5">2 - 5</option>
                    <option value="6 - 15">6 - 15</option>
                    <option value="More than 15">More than 15</option>
                  </b-select>
                </b-field>
              </validation-provider>
            </form>
            <button class="button is-success" :disabled="!checkForm" @click="handleSubmit(submit)"
             >Submit</button>
          </footer>
        </div>
      </validation-observer>
    </template>
  </b-modal>
</template>

<script>

import { mapState } from 'vuex';
import { setQuiz } from '../../api/contractor';

export default {
  name: 'contractorQuiz',
  props: {
    winOpened: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      select1: { question: 'What is your estimated annual business revenue?*', answer: null },
      select2: { question: 'How many employees are in your business?*', answer: null },
      select3: { question: 'How many years have you been in business?*', answer: null },
      placeholder: 'Please Select…',
    };
  },
  mounted() {
  },
  methods: {
    submit() {
      const params = new FormData();
      params.set('contractorId', this.contractor);
      params.set('quiz', JSON.stringify([this.select1, this.select2, this.select3]));
      setQuiz(params).then((response) => {
        if (response.data.error) {
          this.toast(response.data.message, 'is-danger');
        } else {
          this.toast(response.data.message);
          this.$store.commit('RESET_NEED_QUIZ', null, { root: true });
        }
      })
        .finally(() => {
        });
    },
    toast(message, type = 'is-success') {
      this.$buefy.toast.open({ message, type, duration: 5000 });
    },
  },
  computed: {
    ...mapState('contractor', { needQuiz: (state) => state.needQuiz }),
    ...mapState('contractor', { needConfirm: (state) => state.needConfirmServiceAgreement }),
    ...mapState('auth2', { authId: (state) => state.id }),
    ...mapState('user', { userId: (state) => state.id, isContractorUser: (state) => state.isContractorUser }),
    ...mapState('auth2', { contractor: (state) => state.contractor }),
    showQuizModal: (state) => {
      if (
        (state.userId === state.authId) && state.contractor
        && state.needConfirm === false && state.needQuiz
        && state.isContractorUser
      ) {
        return true;
      }
      return false;
    },
    checkForm() {
      return this.select1.answer && this.select2.answer && this.select3.answer;
    },
  },
};
</script>

<style scoped lang="stylus">
.modal-card
  margin-top 0px
  overflow auto
  -ms-text-size-adjust 100%
  -moz-text-size-adjust 100%
  -webkit-text-size-adjust 100%
.modal-card-head
  padding 30px 20px 30px
.modal-card-title
  line-height 1.1
  font-size 1.3rem
  flex-shrink 1
  max-height 9001em
.modal-card-foot
  flex-direction column
  padding 20px 40px 30px
  max-height 9001em
  .quiz-form
    width 100%
    .control
      margin-bottom 15px
    .select.is-empty select
      color rgba(54, 54, 54, 0.3)
  .button.is-success
    min-width 120px
    margin-top 10px
</style>
